export const ADD_PLAN="add_plans"
export const GET_PLANS="get_plans"
export const SET_PLAN="set_plan"
export const SET_INFO1="set_info1"
export const SET_INFO2="set_info2"
export const SET_INFO3="set_info3"